import { ajax } from '@/api/ajax';

export interface ManualListReq {
  /**
   * 车架号，精准
   */
  vin?: string;
  /**
   * 车型编码
   */
  modelCode?: string;
  /**
   * 语言
   */
  lang: string;
  /**
   * 地区
   */
  region: string;
}

export interface ManualListResponse {
  /**
   * 分页对象
   */
  bookmapItemList: ManualRecord[];
  modelCodeName: string;
  seriesCodeName: string;
  modelCode: string;
  auth: boolean;
}

export interface ManualRecord {
  /**
   * 手册编码
   */
  bookmapCode: string;
  /**
   * 手册名称
   */
  bookmapName?: string;
  /**
   * 手册类型，字典：BOOKMAP_TYPE
   * UM-用户手册，RM-维修手册，CRM-车身维修手册，DT-电路图手册，ST-维修工具，RE-救援卡
   */
  bookmapType: string;
  /**
   * 手册类型
   */
  bookmapTypeName?: string;
  /**
   * 版本号
   */
  bookmapVersion: string;
  /**
   * 语言，字典：BASE_LANGUAGE
   */
  lang?: string;
  /**
   * 语言说明
   */
  langName?: string;
  /**
   * 适用车系，EPCM的车系数据
   */
  seriesCode?: string;
  /**
   * 文章链接是否需要鉴权，true为需要
   */
  auth: boolean;
  /**
   * 目录节点类型
   */
  rootType?: string;
  fileId?: string;
}

export function getManualList(data: ManualListReq) {
  return ajax<ManualListResponse>({
    url: '/api/tis/web/bookmap/list',
    method: 'post',
    data: data
  });
}
